import { useList, useDetail, useCreate, useUpdate, useDelete, usePartialUpdate, useAction } from "@inmagik/react-crud"
import { ImmagineAtlante, ImmagineAtlanteFormType, CoordsPayloadImage } from "../types"
import { API_URL } from "../constants"
import { data2formdata } from "../utils/utils"
import { useAuth } from "../auth"
import { useCallback } from "react"
import { fetchApi } from "@inmagik/react-crud"
import { normalizeParams } from "@inmagik/react-crud/dist/crud/utils"

export function useImmaginiAtlante(params: Record<string, string> = {}, enabled:boolean = true) {
  return useList<ImmagineAtlante>(`${API_URL}/admin/immagini-atlante`, {
    query: params,
    

  })
}

export function useImmagineAtlante(id: number | undefined) {
  return useDetail<ImmagineAtlante>(`${API_URL}/admin/immagini-atlante`, id?.toString())
}


export function useImmagineAtlanteCreate() {
  return useCreate<ImmagineAtlante, ImmagineAtlanteFormType>(`${API_URL}/admin/immagini-atlante`, {
    encode: data2formdata,
  })
}

export function useImmagineAtlanteUpdate() {
  return useUpdate<ImmagineAtlante, ImmagineAtlanteFormType>(`${API_URL}/admin/immagini-atlante`, {
    encode: "formdata",
  })
}

export function useImmagineAtlantePartialUpdate() {
  return usePartialUpdate<ImmagineAtlante, ImmagineAtlanteFormType>(`${API_URL}/admin/immagini-atlante`, {
    encode: data2formdata,
  })
}


export function useImmagineAtlanteDelete() {
  return useDelete<ImmagineAtlante>(`${API_URL}/admin/immagini-atlante`)
}


export function useImmagineAtlanteLazy() {
  const auth = useAuth()
  return useCallback((id: number) => {
    return fetchApi(`${API_URL}/admin/immagini-atlante/${id}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<ImmagineAtlante>
  }, [])
}

export function useImmaginiAtlanteLazy() {
  const auth = useAuth()
  return useCallback((params: Record<string, string | number | Array<number>>) => {
    const qs = normalizeParams(params).toString()
    return fetchApi(`${API_URL}/admin/immagini-atlante?${qs}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<{ results: ImmagineAtlante[] }>
  }, [])
}

type PositionsPayload = {
  id: number
  ordine: number
}

export function useUpdateImmaginiAtlantePositions() {
  return useAction<Object, PositionsPayload[]>(`${API_URL}/admin/immagini-atlante/update-positions`, {
    method: "POST",
    responseType: "text",
  })
}


export function useUpdateImageDetailsCoords(id: number) {
  return useAction<ImmagineAtlante, CoordsPayloadImage[]>(`${API_URL}/admin/immagini-atlante/${id}/update-coords`, {
    method: "POST",
    responseType: "json",
  })
}

type DropCoordsPayload = {
 dettaglio: number
}

export function useDropImageDetailCoords(id: number) {
  return useAction<ImmagineAtlante, DropCoordsPayload>(`${API_URL}/admin/immagini-atlante/${id}/drop-coords`, {
    method: "POST",
    responseType: "json",
  })
}